<template>
    <component-loader v-if="plantDetailsLoading" />
    <plant-details
        v-else
        :plantId="plantDetailstoDisplay?.id || props.selectedProject.factStorageId.toString()"
        :plant-details="plantDetailstoDisplay"
        :related-plant-details="relatedEnactData"
        :related-storetrack-details="props.selectedProject"
        :key="props.selectedProject.factStorageId.toString()"
        map-opens-modal
    />
</template>

<script setup lang="ts">

import { plantApi } from '@/api/powerMarkets/plantApi.ts';
import { IPlantDetails, IEnactPlants } from '@/interfaces/powerMarkets/plant/IPlantDetails.ts';
import { ICsvData } from '@/interfaces/storageTracking/ICsvData.ts';
import { ref, watch } from 'vue';
import PlantDetails from '@/components/powerMarkets/plant/PlantDetails.vue';
import { useToast } from 'primevue/usetoast';
import ComponentLoader from '@/components/layout/ComponentLoader.vue';
import { useUserAccessStore } from '@/stores/userAccessStore.ts';

const props = defineProps<{ selectedProject: ICsvData }>();
const userAccessStore = useUserAccessStore();
const toast = useToast();

const plantDetailstoDisplay = ref<IPlantDetails | null>(null);
const relatedEnactData = ref<IEnactPlants | null>(null);
const plantDetailsLoading = ref<boolean>(true);

async function initialise (): Promise<void> {
    plantDetailsLoading.value = true;
    if (!(userAccessStore.shortTermMarketsConfig?.hasPaidShortTermMarketsServices ?? false)) {
        plantDetailsLoading.value = false;
        return;
    }
    try {
        relatedEnactData.value = {
            plants: (await plantApi.getByStoretrackId(props.selectedProject.factStorageId, 1)).data,
            baseName: undefined,
        };

        if (relatedEnactData.value && relatedEnactData.value.plants.length > 0) {
            plantDetailstoDisplay.value = relatedEnactData.value.plants[0];
        }
    } catch (error) {
        toast.add({
            summary: 'Unable to retrieve plant details',
            severity: 'warn',
            detail: error,
            life: 10000,
        });
    } finally {
        plantDetailsLoading.value = false;
    }
}

initialise();

watch(() => props.selectedProject, async () => {
    relatedEnactData.value = null;
    plantDetailstoDisplay.value = null;
    await initialise();
});

</script>
